import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { ResultProperty, TestResultsContainerState } from './testresults';
import { DropdownResponse, User } from '../../domains/app';
import { Test, TestResults } from '../../domains/results';

const initialState: TestResultsContainerState = {
  listUsers: [],
  listExercise: [],
  listTests: [],
  listTestDefinitions: [],
  selectedColumns: [],
  selectedSummaryColumns: [],
  selectedUser: [],
  selectedExercise: undefined,
  litTestResults: [],
};

export const slice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setListUsers: (state, action: PayloadAction<User[]>) => {
      state.listUsers = action.payload;
    },
    setListTests: (state, action: PayloadAction<Test[]>) => {
      state.listTests = action.payload;
    },
    setListTestDefinitions: (state, action: PayloadAction<string[]>) => {
      state.listTestDefinitions = action.payload;
    },
    toggleCheckTest: (state, action: PayloadAction<string>) => {
      const test = state.listTests.find((t) => t.id === action.payload);
      if (test) {
        test.checked = !test.checked;
      }
    },
    toggleAllTests: (state, action: PayloadAction<boolean>) => {
      state.listTests.forEach((t) => {
        t.checked = action.payload;
      });
    },
    setListExercise: (state, action: PayloadAction<DropdownResponse[]>) => {
      state.listExercise = action.payload;
    },
    setSelectedColumns: (state, action: PayloadAction<ResultProperty[]>) => {
      state.selectedColumns = action.payload;
    },
    setSelectedSummaryColumns: (
      state,
      action: PayloadAction<ResultProperty[]>,
    ) => {
      state.selectedSummaryColumns = action.payload;
    },
    setSelectedUser: (state, action: PayloadAction<User[]>) => {
      state.selectedUser = action.payload;
    },
    setSelectedExercise: (state, action: PayloadAction<Test | undefined>) => {
      state.selectedExercise = action.payload;
    },
    setSelectedDefinition: (
      state,
      action: PayloadAction<string | undefined>,
    ) => {
      state.selectedDefinition = action.payload;
    },
    setLitTestResults: (state, action: PayloadAction<TestResults[]>) => {
      state.litTestResults = action.payload;
    },
  },
});

export const {
  setListUsers,
  setListExercise,
  setListTests,
  setListTestDefinitions,
  toggleCheckTest,
  toggleAllTests,
  setSelectedColumns,
  setSelectedSummaryColumns,
  setSelectedUser,
  setSelectedExercise,
  setLitTestResults,
  setSelectedDefinition,
} = slice.actions;

export default slice.reducer;
